const HealthCheck = () => <h1>Healthy</h1>;

export default HealthCheck;
